import { extractImeiFromUrl, storeImei } from './batteri.js';
import { addMachine, lookupSKU } from './produkter.js';
import { toast } from './ui.js';

export let scanStream = null, scanInterval = null, barcodeDetector = null;

export async function startScan() {
  if (!('BarcodeDetector' in window)) { toast('📷 QR-scanning understøttes ikke i denne browser — tast varenummer manuelt'); return; }
  try {
    stopScan();
    scanStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 1280 } } });
    const video = document.getElementById('qrVideo');
    video.srcObject = scanStream;
    await video.play();
    document.getElementById('qrViewfinder').style.display = 'block';
    document.getElementById('qra').style.display = 'none';
    document.getElementById('qrLbl').textContent = 'Scanner…';
    barcodeDetector = new BarcodeDetector({ formats: ['qr_code'] });
    const canvas = document.getElementById('qrCanvas');
    const ctx = canvas.getContext('2d');
    scanInterval = setInterval(async () => {
      if (!scanStream || video.readyState < 2) return;
      canvas.width = video.videoWidth; canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0);
      try {
        const codes = await barcodeDetector.detect(canvas);
        if (codes.length > 0) {
          const raw = codes[0].rawValue;
          const sku = raw.includes('/qr/') ? raw.split('/qr/')[1].trim() : raw.trim().toUpperCase();
          stopScan(); toast('✓ QR aflæst: ' + sku);
          const prod = await lookupSKU(sku);
          if (prod) { await addMachine(prod); }
          else { document.getElementById('skuQr').value = sku; toast('⚠ Varenummer ikke fundet: ' + sku); }
        }
      } catch(e) {}
    }, 400);
  } catch (err) {
    stopScan();
    if (err.name === 'NotAllowedError') toast('❌ Kamera-adgang nægtet');
    else toast('❌ Kamera fejl: ' + err.message);
  }
}

export function stopScan() {
  if (scanInterval) { clearInterval(scanInterval); scanInterval = null; }
  if (scanStream) { scanStream.getTracks().forEach(t => t.stop()); scanStream = null; }
  const vf = document.getElementById('qrViewfinder'); if (vf) vf.style.display = 'none';
  const qra = document.getElementById('qra'); if (qra) qra.style.display = 'block';
  const lbl = document.getElementById('qrLbl'); if (lbl) lbl.textContent = 'Tryk for at scanne';
}

export async function scanQrFromImage(input) {
  const file = input.files[0];
  if (!file) return;
  input.value = '';

  if (!('BarcodeDetector' in window)) {
    // Vis hjælpetekst i stedet for toast der forsvinder
    document.getElementById('batImeiInput').value = '';
    document.getElementById('batImeiInput').placeholder = 'Din browser kan ikke scanne QR fra billede — indsæt URL manuelt';
    document.getElementById('batImeiInput').focus();
    toast('💡 Scan QR-koden med din telefon og kopiér URL\'en herind');
    return;
  }
  try {
    toast('🔍 Analyserer billede…');
    const img = await createImageBitmap(file);
    const bd = new BarcodeDetector({ formats: ['qr_code'] });
    const codes = await bd.detect(img);
    if (codes.length > 0) {
      const raw = codes[0].rawValue;
      const imei = extractImeiFromUrl(raw);
      if (imei) {
        toast('✓ QR-kode aflæst fra billede!');
        await storeImei(imei);
      } else {
        document.getElementById('batImeiInput').value = raw;
        toast('⚠ Tjek URL nedenfor og tryk Gem');
      }
    } else {
      toast('❌ Ingen QR-kode fundet — prøv et skarpere billede');
    }
  } catch(e) {
    toast('❌ Fejl: ' + e.message);
  }
}
